import JobApplicationHcr from './JobApplicationHcr.component';

export default JobApplicationHcr;